var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAspireLogoHori(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "53.95 146.603 354.449 56.234",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    d: "M 385.431 155.086 C 386.349 155.086 386.806 155.527 386.806 156.402 L 386.806 162.089 C 386.806 162.964 386.349 163.406 385.431 163.406 L 359.279 163.406 C 357.724 163.406 356.428 163.543 355.388 163.824 C 354.392 164.062 353.576 164.5 352.935 165.14 C 352.338 165.738 351.92 166.578 351.678 167.652 C 351.439 168.691 351.318 169.988 351.318 171.543 L 351.318 172.14 L 385.131 172.14 C 386.01 172.14 386.447 172.582 386.447 173.457 L 386.447 178.187 C 386.447 179.062 386.01 179.503 385.131 179.503 L 351.318 179.503 L 351.318 180.519 C 351.318 182.074 351.439 183.39 351.678 184.468 C 351.92 185.507 352.338 186.343 352.935 186.984 C 353.576 187.582 354.392 188.019 355.388 188.3 C 356.428 188.539 357.724 188.66 359.279 188.66 L 385.431 188.66 C 386.349 188.66 386.806 189.097 386.806 189.976 L 386.806 195.66 C 386.806 196.539 386.349 196.976 385.431 196.976 L 359.099 196.976 C 356.068 196.976 353.494 196.695 351.381 196.136 C 349.267 195.582 347.529 194.683 346.174 193.445 C 344.857 192.168 343.881 190.535 343.24 188.539 C 342.642 186.503 342.342 184.05 342.342 181.179 L 342.342 170.886 C 342.342 168.011 342.642 165.578 343.24 163.586 C 343.881 161.589 344.857 159.972 346.174 158.738 C 347.529 157.461 349.267 156.543 351.381 155.984 C 353.494 155.386 356.068 155.086 359.099 155.086 L 385.431 155.086 Z M 385.431 155.086",
    fillOpacity: 1,
    fillRule: "nonzero",
    style: {
      fill: "rgb(154, 255, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 189.334 155.086 C 190.213 155.086 190.65 155.527 190.65 156.402 L 190.65 162.089 C 190.65 162.964 190.213 163.406 189.334 163.406 L 159.353 163.406 C 158.197 163.406 157.377 163.703 156.9 164.3 C 156.42 164.902 156.181 165.718 156.181 166.757 L 156.181 168.789 C 156.181 171.023 157.221 172.14 159.295 172.14 L 181.736 172.14 C 185.205 172.14 187.818 173.039 189.576 174.836 C 191.33 176.589 192.209 179.125 192.209 182.433 L 192.209 187.222 C 192.209 190.132 191.349 192.488 189.635 194.285 C 187.92 196.078 185.244 196.976 181.615 196.976 L 148.463 196.976 C 147.545 196.976 147.084 196.539 147.084 195.66 L 147.084 189.976 C 147.084 189.097 147.545 188.66 148.463 188.66 L 179.881 188.66 C 181.037 188.66 181.853 188.359 182.334 187.761 C 182.81 187.164 183.053 186.343 183.053 185.308 L 183.053 182.855 C 183.053 180.621 182.013 179.503 179.939 179.503 L 157.498 179.503 C 154.029 179.503 151.416 178.625 149.658 176.871 C 147.904 175.074 147.025 172.519 147.025 169.211 L 147.025 164.839 C 147.025 161.929 147.885 159.574 149.599 157.781 C 151.314 155.984 153.986 155.086 157.619 155.086 L 189.334 155.086 Z M 189.334 155.086",
    fillOpacity: 1,
    fillRule: "nonzero",
    style: {
      fillRule: "nonzero",
      fill: "rgb(154, 255, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139.806 196.976 L 127.818 196.976 L 124.412 190.668 L 105.166 190.668 L 109.834 181.894 L 119.74 181.894 L 112.736 168.707 L 97.721 196.976 L 85.541 196.976 L 106.49 158.992 C 107.627 156.972 109.267 155.961 111.412 155.961 L 113.935 155.961 C 116.08 155.961 117.721 156.972 118.857 158.992 L 139.806 196.976 Z M 139.806 196.976",
    fillOpacity: 1,
    fillRule: "nonzero",
    style: {
      fill: "rgb(154, 255, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    fillOpacity: 1,
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 201.764 196.652 L 201.764 173 L 237.912 173 C 240.885 172.468 240.885 168.519 240.885 168.519 C 240.6 165.058 237.912 165.058 237.912 165.058 L 201.764 165.058 L 201.764 155.777 L 237.912 155.777 C 252.08 155.777 252.08 168.156 252.08 168.156 C 250.736 183.093 237.912 182.16 237.912 182.16 L 212.146 182.16 L 212.146 196.652 L 201.764 196.652 Z M 201.764 196.652",
    stroke: "#000000",
    strokeOpacity: 1,
    style: {
      fill: "rgb(154, 255, 0)",
      strokeDashoffset: 1,
      strokeMiterlimit: 7.71,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    fillOpacity: 1,
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 270.482 156.187 L 259.166 156.187 L 259.166 196.976 L 270.482 196.976 L 270.482 156.187 Z M 270.482 156.187",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    style: {
      fill: "rgb(154, 255, 0)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    fillOpacity: 1,
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 321.084 156.187 C 321.084 156.187 305.369 156.187 293.361 156.187 C 281.35 156.187 279.721 164.492 279.721 169.089 C 279.721 173.691 279.721 196.937 279.721 196.937 L 291.568 196.937 L 291.568 171.086 C 291.568 166.605 292.506 165.183 296.818 165.183 L 319.088 165.183 C 323.486 165.183 323.607 173.203 319.088 173.203 L 298.857 173.203 L 298.857 182.281 L 311.314 182.281 L 319.088 196.937 L 332.807 196.937 L 323.322 181.546 C 325.885 181.546 333.826 179.429 333.826 167.136 C 332.404 159.273 328.818 156.187 321.084 156.187 Z M 321.084 156.187",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    style: {
      fill: "rgb(154, 255, 0)",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspireLogoHori);
export default __webpack_public_path__ + "static/media/aspire_logo_hori.0d6b4b1dd3c848e400ee7449ffa88114.svg";
export { ForwardRef as ReactComponent };